/**
 * Web-side RBAC for the Data Mapper area.
 *
 * THIN ADAPTER over `auth/tier.ts`, the same pattern as `views/modules/rbac.ts`
 * and `views/infrastructure/rbac.ts`. The Data Mapper is operator tier and
 * above for READS as well as writes (packages/api/src/services/data-mapper/
 * data-mapper-access.ts — its screens edit mappings that become a client's
 * imported data), so a viewer gets nothing from the API at all. The views use
 * this to say so in a sentence instead of rendering a list of refusals, and the
 * stores use it to not call at all.
 *
 * SECURITY: a green light here is never sufficient — every data-mapper service
 * re-checks the tier on every call and refuses API keys outright. This only
 * governs what the UI renders and whether it calls.
 */
import type RootStore from "stores/RootStore";
import { isOperator } from "auth/tier";

/** operator OR admin — may use the Data Mapper. */
export function canUseDataMapper(rootStore: RootStore): boolean {
  return isOperator(rootStore);
}

/** Shown in place of the screens for a viewer. */
export const DATA_MAPPER_NEEDS_OPERATOR =
  "The Data Mapper needs operator access. Ask an administrator to change your role if you need it.";
